import { create } from "zustand";
import { WeightCategory } from "@prisma-remote/client";
import { apiClient } from "src/services/apiClient";

interface WeightCategoryState {
  weightcategories: WeightCategory[];
  fetchWeightCategories: (organisationId?: string) => Promise<void>;
}

export const useWeightCategoryStore = create<WeightCategoryState>((set) => ({
  weightcategories: [],
  fetchWeightCategories: async (organisationId) => {
    const query = organisationId
      ? `?organisationId=${encodeURIComponent(organisationId)}`
      : "";
    try {
      const weightcategories = await apiClient.get<WeightCategory[]>(
        `/weight-categories${query}`,
        { requiresAuth: false },
      );
      set({ weightcategories });
    } catch {
      set({ weightcategories: [] });
    }
  },
}));
